import React from 'react';

export default class CustomDateInput extends React.Component {
  render() {
    return (
      <div className="coral-Form-fieldwrapper--fullWidth coral-InputGroup">
        <input name={ this.props.inputName } className="coral-Form-field coral-Textfield" style={{ margin:0 }} value={ this.props.displayDate } onChange={ this.props.onChangeRaw } disabled={ this.props.disableField } />
        <span className="add-on coral-InputGroup-button">
          <button className="coral-Button coral-Button--secondary coral-Button--square" onClick={ this.props.onClick } disabled={ this.props.disableField }>
            <i className="coral-Icon coral-Icon--sizeS coral-Icon--calendar"></i>
          </button>
        </span>
      </div>
    )
  }
}